import OrganizationService, { OrganizationProps } from 'services/hooks/organization-service';
import TopBar from 'components/elements/TopBar';
import 'react-datepicker/dist/react-datepicker.css';
import LoadingSpinner from 'components/elements/Spinner/LoadingSpinner';
import React, { useEffect, useState } from 'react';
import { Button, Card, CardActions, CardContent, Grid, Typography } from '@mui/material';
import { colours } from 'utils/constants';
import UpdateForm from './OrgForms/save';
import { useQuery } from 'react-query';
import { useAuth } from 'services/auth-service';
import { toast } from 'react-toastify';
import { generateApiFailErrorMessage } from 'utils/helpers';
import { ROLE } from 'utils/roles';

export default function OrgViewModeOnly() {
  const {
    state: { user }
  } = useAuth();
  const [showModal, setShowModal] = useState(false);
  const [editUUID, setEditUUID] = useState('');

  // Fetch Organization Info
  const { data, isLoading, refetch } = useQuery<OrganizationProps, Error>(
    ['organization', user.uuid],
    () => OrganizationService.findOrgById(user.uuid),
    {
      enabled: user.role === ROLE.Org && !!user.uuid,
      onError: () => {
        toast.error(generateApiFailErrorMessage('Organization'));
      }
    }
  );

  useEffect(() => {
    if (showModal) {
      refetch();
    }
  }, [showModal, refetch]);

  // Handle Menu Toggle (for mobile Drawer)
  const handleManage = () => {
    setEditUUID(user?.uuid ? user.uuid : '');
    setShowModal(true);
  };

  // Render Organization Card
  const renderOrgCard = (organization: OrganizationProps) => {
    return (
      <React.Fragment>
        <CardContent>
          <Typography variant="h4" component="div">
            {organization?.name}
          </Typography>
        </CardContent>
        <CardActions>
          <Button
            size="small"
            style={{ textTransform: 'none' }}
            sx={{ color: colours.seafoam, fontWeight: 'bold' }}
            onClick={handleManage}
          >
            Manage
          </Button>
        </CardActions>
      </React.Fragment>
    );
  };

  return !isLoading && data ? (
    <>
      {showModal && (
        <UpdateForm
          entityName={`Update Organization`}
          showModal={showModal}
          setShowModal={setShowModal}
          setEditUUID={setEditUUID}
          editQuery={OrganizationService.findOrgById}
          editUUID={editUUID}
          createQuery={OrganizationService.createOrg}
          updateQuery={OrganizationService.updateOrg}
          queryName={'organization'}
        />
      )}
      <div className="space-y-4">
        <TopBar setGlobalFilter={false} isMessage={true} />
        <h1 className="p-0">Organization</h1>
        <Grid
          container
          spacing={4}
          justifyContent="flex-start"
          sx={{
            '&::after': {
              content: '" "',
              flex: 'auto'
            }
          }}
        >
          <Grid item xs={12} sm={12} md={6} lg={6}>
            <Card variant="outlined" sx={{ borderRadius: '8px', width: '100%' }}>
              {renderOrgCard(data)}
            </Card>
          </Grid>
        </Grid>
      </div>
    </>
  ) : (
    <div>
      <LoadingSpinner />
    </div>
  );
}
